import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from '../../../components/panel/panel.jsx';
import PlaguicidasTabla from './PlaguicidasTabla.jsx';

const PlaguicidasListar = () => {
    return (
      <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Administración de plaguicidas</Link></li>
        <li className="breadcrumb-item active">Listado de plaguicidas</li>
      </ol>
      <h1 className="page-header">Administración de plaguicidas <small></small></h1>
      <Panel>
        <PanelHeader>Plaguicidas registrados</PanelHeader>
        <PanelBody>
            <PlaguicidasTabla/>
        </PanelBody>
      </Panel>
    </div>
    );
  };
  export default PlaguicidasListar;
